import React from "react";

const RANK_STYLES = [
  { bg: "#fff6e0", ring: "rgba(184,134,11,0.18)", text: "#b8860b" },
  { bg: "#f1f3f8", ring: "rgba(120,130,150,0.18)", text: "#6b7894" },
  { bg: "#fdecea", ring: "rgba(217,102,91,0.18)", text: "#c1584d" },
];
const DEFAULT_RANK_STYLE = { bg: "#f1f3f8", ring: "rgba(120,130,150,0.12)", text: "#8a97b4" };

const TsVenueTopContentDashboard = ({ loading = false, topContent = [] }) => {
  const maxCount = topContent.length ? topContent[0].totalCount : 0;

  return (
    <div className="relative flex flex-col gap-4 rounded-[24px] border border-[#e7ebf8] bg-[linear-gradient(180deg,#ffffff_0%,#fbfcff_100%)] px-6 pb-6 pt-5 shadow-[0_16px_34px_rgba(30,52,120,0.06)]">
      <div>
        <h3 className="mb-1 text-[1.1rem] font-semibold tracking-[-0.02em] text-[#1f2d4d]">Top Touchscreen Content</h3>
        <p className="text-sm text-[#6b7894]">Most-clicked touchscreen content items in the selected period.</p>
      </div>

      {loading ? (
        <div className="rounded-[18px] border border-[#e6ebf8] bg-[#fbfcff] px-4 py-4 text-sm text-[#7a88a6]">Loading top content...</div>
      ) : topContent.length === 0 ? (
        <div className="rounded-[18px] border border-[#e6ebf8] bg-[#fbfcff] px-4 py-4 text-sm text-[#7a88a6]">No content clicks recorded for the selected period.</div>
      ) : (
        <div className="flex flex-col gap-2 pt-1">
          {topContent.map((item, index) => {
            const rankStyle = RANK_STYLES[index] || DEFAULT_RANK_STYLE;
            const widthPct = maxCount ? Math.max((item.totalCount / maxCount) * 100, 4) : 0;
            return (
              <div key={item.content_id || item.name} className="flex items-start gap-3 rounded-[16px] border border-[#e6ebf8] bg-white px-4 py-3 shadow-[0_10px_20px_rgba(15,23,42,0.03)]">
                <span
                  className="flex h-8 w-8 flex-none items-center justify-center rounded-full text-sm font-bold"
                  style={{ backgroundColor: rankStyle.bg, boxShadow: `0 0 0 4px ${rankStyle.ring}`, color: rankStyle.text }}
                >
                  {index + 1}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="break-words text-sm font-medium leading-snug text-[#1f2d4d]">
                    {item.name}
                  </div>
                  <div className="mt-1.5 h-1.5 w-full rounded-full bg-[#eef1f8]">
                    <div
                      className="h-1.5 rounded-full bg-[#4a63ff]"
                      style={{ width: `${widthPct}%` }}
                    />
                  </div>
                </div>
                <span className="flex-none text-sm font-semibold text-[#1f2d4d]">{item.totalCount.toLocaleString()}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default TsVenueTopContentDashboard;
